module.exports = {"data":{"site":{"siteMetadata":{"title":"Buoy Health: Check Symptoms & Find the Right Care","description":"Check your symptoms and clarify your options for care. The Buoy A.I. health assistant guides you on your way to well, the moment you feel sick.","symptomCheckerPath":"symptom-checker/","mainImagePath":"images/"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 196
// module chunks = 60335399758886 114276838955818